import React from 'react'
import {useNavigate, useLocation} from 'react-router'
import {KP11LinkCatalogContainerStyle} from './kp-11Link-catalog-style'
import {KP11LinkCatalogCardWrapperComponent} from './kp-11Link-catalog-cards/kp-11Link-catalog-card-wrapper'

export function KP11LinkCatalogComponent({
  selectedCountry,
  centersNAppVList,
  catalogGroups,
  setCatalogGroups,
  allGroupCustomFieldsMap,
  setAllGroupCustomFieldsMap,
  defaultAllGroupCustomFieldsMap,
  defaultCartCentersNApps,
  customerInfo,
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const fromAccounts = !!location.state?.accountCode

  const {company, displayName, accountCode, billToLabel} = customerInfo || {}
  const showCustomerCard = company || displayName || accountCode || billToLabel
  const avatarInitial = (company || displayName || '?').charAt(0).toUpperCase()

  return (
    <KP11LinkCatalogContainerStyle>
      <div className="catalog-header">
        <div className="catalog-header-left">
          <div
            className="back-link"
            onClick={() => {
              if (fromAccounts) {
                navigate('/control-center', {
                  state: {activePanel: 'Account Management'},
                })
              } else {
                navigate('/')
              }
            }}
          >
            &lt; Back To Portal
          </div>
          <div className="brand-title">Thryv Catalog</div>
        </div>
        {showCustomerCard && (
          <div className="customer-info-card">
            <div className="customer-info-main">
              <div className="customer-avatar">{avatarInitial}</div>
              <div className="customer-text">
                <div className="customer-label">Customer</div>
                {company && <div className="customer-company">{company}</div>}
                {displayName && (
                  <div className="customer-name">{displayName}</div>
                )}
              </div>
            </div>
            {(billToLabel || accountCode) && (
              <div className="customer-meta">
                {billToLabel && (
                  <div className="customer-meta-row">
                    <span className="label">Bill To</span>
                    <span className="value customer-bill-to-value">
                      {billToLabel}
                    </span>
                  </div>
                )}
                {accountCode && (
                  <div className="customer-meta-row">
                    <span className="label">Thryv ID</span>
                    <span className="value">{accountCode}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* {loading && <div>Loading catalog...</div>} */}

      {centersNAppVList && Object.keys(centersNAppVList).length > 0 && (
        <KP11LinkCatalogCardWrapperComponent
          selectedCountry={selectedCountry}
          // defaultCentersNAppList={defaultCentersNAppList}
          catalogGroups={catalogGroups}
          setCatalogGroups={setCatalogGroups}
          allGroupCustomFieldsMap={allGroupCustomFieldsMap}
          setAllGroupCustomFieldsMap={setAllGroupCustomFieldsMap}
          defaultAllGroupCustomFieldsMap={defaultAllGroupCustomFieldsMap}
          defaultCartCentersNApps={defaultCartCentersNApps}
          centersNAppVList={centersNAppVList}
        />
      )}

      {/* {!loading && Object.keys(defaultCentersAndApps).length === 0 && ( */}
      {centersNAppVList && Object.keys(centersNAppVList).length === 0 && (
        <div>No catalog items available.</div>
      )}
    </KP11LinkCatalogContainerStyle>
  )
}
